import { useEffect } from "react";
import { applyTheme } from "../context/SiteContext";

export const PLATFORM = {
  name: "Hostech Solutions",
  tagline: "innovating hospitality",
  product: "Booking Engine Platform",
  logo: "/brand/hostech-logo.png",
  icon: "/brand/hostech-icon.png",
  website: "https://hostechsolutions.com/",
  email: "info@hostechsolutions.co.ke",
};

export const PLATFORM_THEME = {
  primary: "#263562", primary_dark: "#1E2A4A", primary_light: "#E3F3FB", accent: "#3AB0E1",
  background: "#FFFFFF", surface: "#F5F8FC", ink: "#1E2A4A", heading_font: "Tinos", body_font: "Quicksand", radius: 14,
};

export const usePlatformTheme = () => {
  useEffect(() => {
    applyTheme(PLATFORM_THEME);
    const prev = document.title;
    document.title = `${PLATFORM.name} · ${PLATFORM.product}`;
    return () => {
      document.title = prev;
    };
  }, []);
};

export const PoweredBy = ({ className = "" }) => (
  <a href={PLATFORM.website} target="_blank" rel="noreferrer" className={`inline-flex items-center gap-2 text-xs text-ink/50 hover:text-ink ${className}`} data-testid="powered-by-hostech">
    <img src={PLATFORM.icon} alt="" className="h-4 w-4" />Powered by {PLATFORM.name}
  </a>
);
